import { MdClose } from 'react-icons/md';
import Input from '@/components/Input';
import Select from '@/components/Select';
import useActiveUsers from '@/features/agent/active_users/hooks/useActiveUsers';
import type { AllianceSortOrder } from '../api/useFetchAllianceApplications';

const sortItems = [
  { value: 'updated_at_desc', label: '最終更新順' },
  { value: 'applied_at_desc', label: '応募日（新しい順）' },
  { value: 'applied_at_asc', label: '応募日（古い順）' },
];

interface Props {
  keyword: string;
  sort: AllianceSortOrder;
  agentId: string;
  onKeywordChange: (value: string) => void;
  onSortChange: (value: AllianceSortOrder) => void;
  onAgentIdChange: (value: string) => void;
  onClear: () => void;
}

export default function ApplicationFilterBar({
  keyword,
  sort,
  agentId,
  onKeywordChange,
  onSortChange,
  onAgentIdChange,
  onClear,
}: Props) {
  const isFilterActive = keyword !== '' || agentId !== 'all' || sort !== 'updated_at_desc';
  const { data: activeUsersData } = useActiveUsers();
  const agentItems = [
    { value: 'all', label: '全ての担当者' },
    ...(activeUsersData?.activeUsers ?? []).map((user) => ({
      value: String(user.id),
      label: user.name,
    })),
  ];

  return (
    <div className="flex flex-col gap-sm">
      <div className="flex gap-lg rounded bg-white p-md shadow-layer1">
        <div className="w-[460px]">
          <Input
            search
            placeholder="フリーワードで絞り込む"
            value={keyword}
            onChange={(e) => onKeywordChange(e.target.value)}
            className="w-full"
          />
        </div>
        <div className="w-[236px]">
          <label htmlFor="alliance-filter-agent" className="sr-only">
            担当者
          </label>
          <Select
            id="alliance-filter-agent"
            items={agentItems}
            value={agentId}
            onValueChange={onAgentIdChange}
            defaultLabel="全ての担当者"
            className="w-full"
          />
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="w-[196px]">
          <label htmlFor="alliance-filter-sort" className="sr-only">
            並び順
          </label>
          <Select
            id="alliance-filter-sort"
            items={sortItems}
            value={sort}
            onValueChange={(v) => onSortChange(v as AllianceSortOrder)}
            className="w-full"
          />
        </div>
        <button
          type="button"
          onClick={onClear}
          disabled={!isFilterActive}
          className="flex items-center gap-xxs border-none bg-transparent p-0 text-body-sm font-bold text-primary hover:opacity-70 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:opacity-50"
        >
          <MdClose className="size-5" />
          検索条件をクリア
        </button>
      </div>
    </div>
  );
}
